import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_n2jsjnhwd3: FaireBrandEntity = {
  token: "b_n2jsjnhwd3",
  type: "brand",
  name: "Furano Studio",
  avatarUrl:
    "https://cdn.faire.com/fastly/c044c02cac74d3df004a27be5fc72b30d3d27a5efefe4f640bdf4c73ebe982a1.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/569dec51bbdc440583f5536bbc4716874f88909030e037c93f770e472fa66daf.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c044c02cac74d3df004a27be5fc72b30d3d27a5efefe4f640bdf4c73ebe982a1.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/569dec51bbdc440583f5536bbc4716874f88909030e037c93f770e472fa66daf.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 26,
  isTopShop: true,
  isInsider: true,
  description:
    "Visit us @ www.furanostudio.com or www.furanostudio.etsy.com for more retail styles and customer reviews!\nFollow us @furanostudio on Instagram/TikTok for product updates/promotions!",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:16.860Z",
    importedBy: "entity-db-cli",
  },
};
